import React, { useEffect, useState } from 'react';
import { Card, Col, Button, Form, Alert, Spinner } from 'react-bootstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from '../../Common/withRouter';

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunk";
import { createSelector } from 'reselect';

import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

// Import api helper to ensure axios is configured
import { setAuthorization } from "../../helpers/api_helper";

// Enable axios debugging
if (process.env.NODE_ENV === 'development') {
  console.log('=== AXIOS CONFIGURATION ===');
  console.log('Base URL:', axios.defaults.baseURL);
  console.log('Default Headers:', axios.defaults.headers);
}

const Login = () => {
    const dispatch: any = useDispatch();
    const selectAccountAndLogin = createSelector(
        (state: any) => state.Account,
        (state: any) => state.Login,
        (account, login) => ({
            user: account.user,
            error: login.error,
            loading: login.loading,
            errorMsg: login.errorMsg,
        })
    );

    const { user, error, loading, errorMsg } = useSelector(selectAccountAndLogin);
    const [email, setemail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [userLogin, setUserLogin] = useState<any>([]);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    const navigate = useNavigate();
    useEffect(() => {
        const token = localStorage.getItem("authToken");
        const user = localStorage.getItem("authUser");

        // Debug logging
        console.log('Login - Checking localStorage...');
        console.log('Token:', token);
        console.log('User:', user);

        // Only redirect if both token and user exist and are valid
        if (token && token !== 'null' && token !== 'undefined' && token !== '' &&
            user && user !== 'null' && user !== 'undefined' && user !== '') {
            console.log('Already logged in, redirecting to dashboard');
            navigate("/dashboard", { replace: true });
        }
    }, [navigate]);

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email || 'yogiramdani666@gmail.com',
            password: userLogin.password || 'Kmzway87aa!',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values) => {
            setIsSubmitting(true);

            try {
                console.log('=== LOGIN REQUEST START ===');
                console.log('Request URL:', axios.defaults.baseURL + '/users/login');
                console.log('Request Data:', {
                    email: values.email,
                    password: values.password,
                });

                // Option 1: Using Axios (original method)
                const response = await axios.post("/users/login", {
                    email: values.email,
                    password: values.password,
                });

                // Alternative Option 2: Using Fetch API (uncomment to test)
                // const response = await fetch(axios.defaults.baseURL + '/users/login', {
                //     method: 'POST',
                //     headers: {
                //         'Content-Type': 'application/json',
                //     },
                //     body: JSON.stringify({
                //         email: values.email,
                //         password: values.password,
                //     }),
                // });
                // const responseData = await response.json();
                // console.log('=== FETCH RESPONSE ===');
                // console.log('Fetch Response:', response);
                // console.log('Fetch Data:', responseData);

                console.log('=== FULL RESPONSE ===');
                console.log('Response Status:', response.status);
                console.log('Response Headers:', response.headers);
                console.log('Full Response Object:', response);
                console.log('Response Data:', response.data);
                
                // Handle response data - the server returns data in response.data.data structure
                let responseData = response.data;
                console.log('Processed Response Data:', responseData);
                console.log('Response Data Type:', typeof responseData);
                console.log('Has data property:', responseData.hasOwnProperty('data'));
                
                if (responseData.data) {
                    console.log('Nested data found:', responseData.data);
                    console.log('Access token in nested:', responseData.data.access_token);
                    console.log('User in nested:', responseData.data.user);
                }

                // Extract access_token and user from the correct nested structure
                const access_token = responseData.data?.access_token || responseData.access_token;
                const user = responseData.data?.user || responseData.user;

                console.log('=== EXTRACTED DATA ===');
                console.log('Access Token:', access_token);
                console.log('User Data:', user);

                if (!access_token) {
                    console.error('No access token found in response structure:');
                    console.error('Available properties in response.data:', Object.keys(responseData));
                    if (responseData.data) {
                        console.error('Available properties in response.data.data:', Object.keys(responseData.data));
                    }
                    throw new Error('No access token received from server');
                }

                if (!user) {
                    console.error('No user data found in response structure');
                    throw new Error('No user data received from server');
                }

                localStorage.setItem("authUser", JSON.stringify(user));
                localStorage.setItem("authToken", access_token);

                // Set authorization header for subsequent requests
                setAuthorization(access_token);

                // Verify storage
                const storedToken = localStorage.getItem("authToken");
                const storedUser = localStorage.getItem("authUser");
                console.log('=== STORAGE VERIFICATION ===');
                console.log('Stored token:', storedToken);
                console.log('Stored user:', storedUser);

                Swal.fire({
                    icon: 'success',
                    title: 'Login Successfully',
                    showConfirmButton: false,
                    timer: 1000,
                }).then(() => {
                    setIsSubmitting(false);
                    console.log('Navigating to dashboard...');
                    
                    // Small delay to ensure localStorage is properly set
                    setTimeout(() => {
                        navigate("/dashboard", { replace: true });
                    }, 100);
                });
            
            } catch (error: any) {
                console.log('=== LOGIN ERROR ===');
                console.log('Full Error Object:', error);
                console.log('Error Response:', error.response);
                console.log('Error Message:', error.message);
                
                if (error.response) {
                    console.log('Error Status:', error.response.status);
                    console.log('Error Data:', error.response.data);
                    console.log('Error Headers:', error.response.headers);
                }

                const errorMessage = error.response?.data?.message || error.message || "An error occurred";
                setErrorMessage(errorMessage);
                
                Swal.fire({
                    icon: 'error',
                    title: 'Login Failed',
                    text: errorMessage,
                    showConfirmButton: true,
                });
                setIsSubmitting(false);
            }
        }   
    });

    document.title = "Login | CITY APPS";
    return (
        <ParticlesAuth>
            <React.Fragment>
                <Col xxl="6" className="mx-auto">
                    <Card className="mb-0 border-0 shadow-none mb-0">
                        <Card.Body className="p-sm-5 m-lg-4">
                            <div className="text-center mt-5">
                                <h5 className="fs-3xl">Welcome</h5>
                                <p className="text-muted">Sign in to continue.</p>
                            </div>
                            <div className="p-2 mt-5">
                                {error && error ? (<Alert variant="danger"> {error} </Alert>) : null}

                                <Form action="#" onSubmit={(e) => {
                                    e.preventDefault(); validation.handleSubmit();
                                    return false;
                                }}>

                                    <Form.Group className="mb-3" controlId="formemail">
                                        <Form.Label>email <span className="text-danger">*</span></Form.Label>
                                        <div className="position-relative">
                                            <Form.Control type="email" name="email" className="form-control password-input" placeholder="Enter email" required
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.email || ""}
                                                isInvalid={
                                                    validation.touched.email && validation.errors.email ? true : false
                                                }
                                            />
                                        </div>
                                        {validation.touched.email && validation.errors.email ? (
                                            <Form.Control.Feedback type="invalid">{validation.errors.email}</Form.Control.Feedback>
                                        ) : null}
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="formPassword">
                                        {/* <div className="float-end">
                                            <Link to={process.env.PUBLIC_URL + "/forgot-password"} className="text-muted">Forgot password?</Link>
                                        </div> */}
                                        <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                                        <div className="position-relative auth-pass-inputgroup mb-3">
                                            <Form.Control type={passwordShow ? "text" : "password"} className="form-control pe-5 password-input" placeholder="Enter password" required
                                                name="password"
                                                value={validation.values.password || ""}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                isInvalid={
                                                    validation.touched.password && validation.errors.password ? true : false
                                                }
                                            />
                                            {validation.touched.password && validation.errors.password ? (
                                                <Form.Control.Feedback type="invalid">{validation.errors.password}</Form.Control.Feedback>
                                            ) : null}
                                            <Button variant="link" className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></Button>
                                        </div>
                                    </Form.Group>

                                    <Form.Group controlId="formRememberMe">
                                        <Form.Check type="checkbox" label="Remember me" id="auth-remember-check" />
                                    </Form.Group>

                                    <div className="mt-4">
                                        {/* <Button className="btn btn-primary w-100" type="submit" disabled={loading}> {loading && <Spinner size='sm' />} {" "}Sign In</Button> */}
                                        <button
                                            className="btn btn-primary w-100"
                                            type="submit" // Bukan "submit" agar kita bisa menangani validasi manual
                                            onClick={async () => {
                                                const errors = await validation.validateForm(); // Jalankan validasi eksplisit
                                                validation.setTouched(
                                                    Object.keys(validation.initialValues).reduce((acc, key) => {
                                                        acc[key] = true;
                                                        return acc;
                                                    }, {} as Record<string, boolean>)
                                                );

                                                if (Object.keys(errors).length > 0) {
                                                    const errorMessages = Object.values(errors).join("\n");
                                                    Swal.fire({
                                                        icon: "warning",
                                                        title: "Validation Error",
                                                        text: `Please fix the following errors:\n${errorMessages}`,
                                                    });
                                                    return;
                                                }

                                                validation.handleSubmit(); // Jalankan submit manual
                                            }}
                                        >

                                            {isSubmitting ? (
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            ) : (
                                                <i className="ri-printer-line align-bottom me-1"></i>
                                            )}
                                            {isSubmitting ? "Proccess..." : "Sign In"}
                                        </button>
                                    </div>

                                    

                                </Form>

                                
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </React.Fragment>
        </ParticlesAuth>
    );
};

export default Login;